<template>

  <div class="container-fluid row container-temperature" v-if="me">

<!--    <div class="col-md-3 col-sm-12  left-sidebar">-->

<!--      <div class="tab-header first-content">-->
<!--       <div class="row">-->
<!--         <div class="col-md-12 col-sm-12 d-flex align-items-start ">-->
<!--           <div>-->
<!--             <img src="/svgs/home.svg" alt="">-->
<!--           </div>-->
<!--           <div class="text-side d-flex flex-column justify-content-start">-->
<!--             <span>კომპანიის სახელი</span>-->
<!--             <span class="second-title">{{  me.data.firma ?  me.data.firma.name : 'არ აქვს ფირმა' }}</span>-->
<!--           </div>-->
<!--         </div>-->

<!--         <div class="col-md-12 col-sm-12 d-flex align-items-start ">-->
<!--           <div>-->
<!--             <img src="/svgs/user-blue.svg" alt="">-->
<!--           </div>-->
<!--           <div class="text-side d-flex flex-column justify-content-start">-->
<!--             <span>მომხმარებელი</span>-->
<!--             <span class="second-title">{{ me.data.nickname }}</span>-->
<!--           </div>-->
<!--         </div>-->



<!--         <div class="col-md-12 col-sm-12 d-flex align-items-start ">-->
<!--           <div>-->
<!--             <img src="/svgs/hashtag.svg" alt="">-->
<!--           </div>-->
<!--           <div class="text-side d-flex flex-column justify-content-start">-->
<!--             <span>აბონენტის ნომერი</span>-->
<!--             <span class="second-title font-roboto">{{ me.data.firma.id }}</span>-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->

<!--      </div>-->

<!--    </div>-->

    <div class="col-md-7 col-sm-12 row  right-content">

      <form action="" @submit.prevent="updateProfile">
        <div class="title-panel d-flex justify-content-between align-items-center  content-header">

          <div class="title-text">
            პირადი ინფორმაცია
          </div>
        </div>

        <div class="tab-header" v-if="me">

          <div class="row">

            <div class="col-6 form-group">
              <label class="form-label" for="name">სახელი</label>
              <input class="form-control" name="name" v-model="me.data.name" id="name" required/>
            </div>

            <div class="col-6 form-group">
              <label class="form-label" for="surname">გვარი</label>
              <input class="form-control" name="surname" v-model="me.data.surname" id="surname" />
            </div>

            <div class="col-6 form-group">
              <label class="form-label" for="email">ელ.ფოსტა</label>
              <input class="form-control" name="name" v-model="me.data.email" id="email" />
            </div>

            <div class="col-6 form-group">
              <label class="form-label" for="tel">ტელეფონი</label>
              <input class="form-control" name="tel" v-model="me.data.tel" id="tel" />
            </div>


            <div class="col-6 form-group">
              <label class="form-label" for="language">ენა</label>
              <v-select v-model="me.data.language" label="name" id="warehouse-name" :options="[{locale:'ge', name:'ქართული'}, {name:'English',locale: 'en'}]">
                <template v-slot:no-options>სია ცარიელია</template>
              </v-select>
            </div>

            <div class="title">
              პაროლის შეცვლა
            </div>
          </div>
        </div>

        <div class="row password-panel">
          <div class="col-6 form-group">
            <label class="form-label" for="current_password">მიმდინარე პაროლი</label>
            <input class="form-control" name="current_password" v-model="current_password" id="current_password" />
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="password">ახალი პაროლი</label>
            <input class="form-control" name="password" v-model="password" id="password" />
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="password_confirmation">გაიმეორეთ პაროლი</label>
            <input class="form-control" name="password_confirmation" v-model="password_confirmation" id="password_confirmation" />
          </div>
        </div>

        <div class="row button-panel d-flex align-content-end align-items-end justify-content-end ">
          <div class="cold-12 d-flex align-content-end align-self-end col-3 form-group">
            <button type="submit" class="btn btn-primary">შენახვა</button>
          </div>

        </div>


      </form>


    </div>

  </div>

</template>

<script>
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";

export default {
  name:'EditUSerInformation',
  computed:{
    me(){
      return this.$store.state.user.me
    },
    errorOcurred(){
      return this.$store.state.user.error
    }
  },
  methods:{
    temperatureUnit(unit){
      if (unit === "CT"){
        return '℃'
      }
    },
    async updateProfile(){

      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return 0
      }else{
        this.loading = true
        let reqData = {}
        this.loading = true
        if(this.current_password){
          reqData.password = this.password
          reqData.password_confirmation = this.password_confirmation
          reqData.current_password = this.current_password
        }

        let data = {
         ...this.me.data, ...reqData, ...{language: this.me.data.language.locale}
        }
        this.$store.dispatch('user/update', data).then(
            ()  => this.loading = false
        )
      }

    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){

    return {
      nickname: ref(null),
      name: ref("ss"),
      surname: ref(null),
      email: ref(null),
      tel: ref(null),
      language: ref(null),
      current_password:ref(null),
      password:ref(null),
      password_confirmation:ref(null),
      loading: false,
    }
  },
  mounted() {
    this.$store.state.user.error = null
    this.$store.dispatch('user/me').then(
        () => {
          this.loading = false
          if (this.me){
            this.me.data.language =  this.me.data.language === 'en' ? {name:'English',locale:'en'} : {name:'ქართული',locale:'ge'}
          }
        }
    )
  },
  validations () {
    return {
      name: { required },
    }
  }
}
</script>

<style scoped>

.text-side{
  margin-left: 3%;
  padding-left: 5%;
}

.text-side {
  font-size: 14px;
}

.text-side .second-title{
  font-size: 12px;
}
.tab-header{
  margin: 0;
  padding: 0 15px 0 0;
}
.tab-header:not(:first-child){
  border:1px solid var(--border-color);
  border-top: 0;
  border-bottom: 0;
}
.first-content{
  border-radius: 5px;
  margin-top: 5px;
}

.row{
  padding: 15px;
}

.form-group{
  margin-top: 1.5%;
  margin-left: 0;
}



.input-group-text{
  border: 1px solid var(--dropzone-border);
  background: #ffffff;
}

 .form-control{
   border: 1px solid var(--dropzone-border);
 }

 .title-panel{
   width: 100%;
   padding: 15px 15px 10px;
   margin: 5px 0 0;
   border:1px solid var(--border-color);
   border-radius: 5px 5px 0 0;
 }

 .left-sidebar{
   margin: 20px 15px;
   border:1px solid var(--border-color);
   border-radius: 5px;
 }


 .button-panel{
   margint-top:0;
   margin-left: 0;
   margin-right: 0;
   border:1px solid var(--border-color);
   width: 100%;
   padding-top: 10px;
   border-bottom-left-radius: 5px;
   border-bottom-right-radius: 5px;
 }

.password-panel{
  margint-top:0;
  margin-left: 0;
  margin-right: 0;
  border:1px solid var(--border-color);
  width: 100%;
  padding: 10px 0 25px;
  border-bottom: 0;
}

.title{
  padding-top:5%;
  padding-bottom: 0;
}
.error-occurred{
  color:red;
}

@media only screen and (min-width: 1198px) and (max-width: 1679px) {
  .right-content{
    height: 70vh;
    overflow: auto;
  }
  .title-text{
    font-size: 14px;
  }
}

</style>